import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar, MessageCircle, Mail } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Reserved = () => {
  const [searchParams] = useSearchParams();

  const { date, from, to } = useMemo(() => {
    return {
      date: searchParams.get("date") || "7 September",
      from: searchParams.get("from") || "7 PM",
      to: searchParams.get("to") || "8 PM",
    };
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />

      <main className="flex-1 pt-32 pb-20 px-6">
        <div className="max-w-xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-card border border-border rounded-2xl p-8 md:p-10 text-center"
          >
            <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary/10 flex items-center justify-center">
              <Calendar className="w-8 h-8 text-primary" />
            </div>

            <h1 className="text-3xl md:text-4xl font-funnel font-semibold text-primary mb-3">
              This time is reserved
            </h1>
            <p className="text-foreground/70 leading-relaxed mb-2">
              This pod is reserved from <strong>{from}</strong> to <strong>{to}</strong> on <strong>{date}</strong>.
            </p>
            <p className="text-foreground/70 leading-relaxed mb-8">
              Please come back at another time, or get in touch to book your next session.
            </p>

            <div className="bg-muted/50 rounded-xl p-5 text-left space-y-4">
              <p className="text-primary text-base font-semibold normal-case tracking-normal">
                Want to reserve the pod for a specific time?
              </p>
              <p className="text-foreground/70 leading-relaxed">
                Most qwip sessions are booked on the spot when you arrive.
                <br />
                <br />
                If you’d prefer to guarantee a pod for a particular date and time, you can also reserve in advance.
                <br />
                <br />
                Message us on WhatsApp or email us at{" "}
                <a
                  href="mailto:hello@qwip.co.uk"
                  className="underline text-primary hover:text-primary/80"
                >
                  hello@qwip.co.uk
                </a>{" "}
                with your preferred date and time and we'll get back to you.
              </p>
              <a
                href="https://wa.me/447347474059"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-primary text-white font-medium px-5 py-2.5 rounded-full hover:opacity-90 transition-opacity"
              >
                <MessageCircle className="w-4 h-4" />
                Message us on WhatsApp
              </a>
              <a
                href="mailto:hello@qwip.co.uk"
                className="inline-flex items-center gap-2 border border-border text-foreground font-medium px-5 py-2.5 rounded-full hover:bg-muted transition-colors ml-0 sm:ml-3 mt-3 sm:mt-0"
              >
                <Mail className="w-4 h-4" />
                Email us
              </a>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Reserved;
